import { Injectable } from '@angular/core';
import { AppIcon } from '@capacitor-community/app-icon';

export const ICON_DISABLED = 'Disabled';

@Injectable({
  providedIn: 'root',
})
export class AppIconService {
  async changeIcon(iconName: string): Promise<void> {
    await AppIcon.change({ name: iconName, suppressNotification: false });
  }

  async resetIcon(): Promise<void> {
    await AppIcon.reset({ suppressNotification: false });
  }
}
